import headerImg from '../../../assets/serviceHeader.svg'

import img1 from '../../../assets/dummy1.avif'
import img2 from '../../../assets/dummy2.avif'
import img3 from '../../../assets/dummy3.avif'

import backend from '../../../assets/services-web-App/backend.svg'
import designer from '../../../assets/services-web-App/designer.svg'
import frontend from '../../../assets/services-web-App/frontend.svg'
import product from '../../../assets/services-web-App/product.svg'
import quality from '../../../assets/services-web-App/quality.svg'

import support from '../../../assets/services-web-App/support.svg'
import prototype from '../../../assets/services-web-App/prototype.svg'
import planning from '../../../assets/services-web-App/planning.svg'
import devops from '../../../assets/services-web-App/devops.svg'
import deployment from '../../../assets/services-web-App/deployment.svg'

import portals from '../../../assets/services-web-App/portals.svg'
import enterprise from '../../../assets/services-web-App/enterprise.svg'
import webConsulting from '../../../assets/services-web-App/web-consulting.svg'
import cloudBased from '../../../assets/services-web-App/cloud-based.svg'
import progressive from '../../../assets/services-web-App/progressive.svg'
import supplyChain from '../../../assets/services-web-App/supply-chain.svg'

import decision from '../../../assets/services-web-App/decision.svg'
import experience from '../../../assets/services-web-App/experience.svg'
import problemSolver from '../../../assets/services-web-App/problemSolver.svg'

import img from '../../../assets/services/img.svg'


import myimg1 from '../../../assets/services-web-App/tech/img1.svg'
import myimg2 from '../../../assets/services-web-App/tech/img2.svg'
import myimg3 from '../../../assets/services-web-App/tech/img3.svg'
import img4 from '../../../assets/services-web-App/tech/img4.svg'
import img5 from '../../../assets/services-web-App/tech/img5.svg'
import img6 from '../../../assets/services-web-App/tech/img6.svg'
import img7 from '../../../assets/services-web-App/tech/img7.svg'
import img9 from '../../../assets/services-web-App/tech/img9.svg'
import img10 from '../../../assets/services-web-App/tech/img10.svg'
import img11 from '../../../assets/services-web-App/tech/img11.svg'
import img12 from '../../../assets/services-web-App/tech/img12.svg'
import img13 from '../../../assets/services-web-App/tech/img13.svg'
import img14 from '../../../assets/services-web-App/tech/img14.svg'
import img15 from '../../../assets/services-web-App/tech/img15.svg'
import img16 from '../../../assets/services-web-App/tech/img16.svg'
import img17 from '../../../assets/services-web-App/tech/img17.svg'
import img18 from '../../../assets/services-web-App/tech/img18.svg'
import img19 from '../../../assets/services-web-App/tech/img19.svg'
import img20 from '../../../assets/services-web-App/tech/img20.svg'
import img22 from '../../../assets/services-web-App/tech/img22.svg'
import img23 from '../../../assets/services-web-App/tech/img23.svg'
import img24 from '../../../assets/services-web-App/tech/img24.svg'

import review from '../../../assets/dummyreview.png'


export const headerData = {
    title1: 'Custom Blockchain',
    title2: 'Development Services',
    desc: 'We are a leading custom Blockchain development company that creates scalable Blockchain with high-quality standards. Thoroughly examining your preferences, requirements and expectations, our community of 500+ developers deliver top-notch web app development services to enhance your customer retention and boost brand equity. Have a look at our customer-centric services:',
    points: [
        'Daily collaborative meetings with product managers',
        'Free full-cycle quality assurance',
        'Wallet-friendly engagement models to hire developers'
    ],
    img: headerImg
}

export const BenefitsData = {
    title1: 'Kickstart Your Project with Our Personalized',
    title2: 'Blockchain Development Services',
    desc: 'As the leading and trusted development company all over the world, we offer a personalized package of value-added services.',
    cards: [
        {
            title: 'Pocket-Friendly Services',
            desc: 'End up saving thousands of dollars with our exclusive and customized web application development services, which include a 7-day trial, experienced product managers, and full-cycle application testing and debugging.'
        },
        {
            title: 'Full Transparency',
            desc: 'Track the progress of the best web application development process with ease. A daily meeting with our product managers will keep you in the loop, treating your feedback as a valuable insight to deliver a bug-free final product.'
        },
        {
            title: 'Community of large Tech Veterans',
            desc: 'Codezone has hands-on expertise in web application development services and a thriving community of large developers that have achieved 97% client satisfaction across sectors such as Healthcare, Fintech, and more!'
        },
        {
            title: 'Specialized in Most Advanced Tech Stack',
            desc: 'Utilize the expertise of our proficient developers who have a strong grasp on the most popular programming languages, frameworks, databases, and other toolkit suites.'
        },
        {
            title: '100% Confidentiality As Promised',
            desc: 'You may be confident in the secrecy of your project! Our web app development team prioritizes cutting-edge technology and techniques to safeguard your data and other essential information.'
        },
    ]
}

export const recentworkdata = {
    title1: 'Our Recent',
    title2: 'Work',
    sliderData: [
        {
            title: 'dummy 1',
            img: [img1],
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis repellendus quidem voluptatem aspernatur, quisquam cum debitis quis consectetur dolor voluptates cumque laboriosam! Possimus architecto nisi omnis veritatis minus ab minima.  '
        },
        {
            title: 'dummy 2',
            img: [img2],
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis repellendus quidem voluptatem aspernatur, quisquam cum debitis quis consectetur dolor voluptates cumque laboriosam! Possimus architecto nisi omnis veritatis minus ab minima.  '
        },
        {
            title: 'dummy 3',
            img: [img3],
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis repellendus quidem voluptatem aspernatur, quisquam cum debitis quis consectetur dolor voluptates cumque laboriosam! Possimus architecto nisi omnis veritatis minus ab minima.  '
        },
    ]
}

export const SuccessDrivenData = {
    title1: 'Build A Success-Driven Development Team To',
    title2: 'Protect Your Project Scope',
    desc: 'Prevent scope creep, frequent delays and unplanned changes by building a development team. Here’s what a success-driven development team looks like.',
   cards: [
    {
        title: 'Frontend Developers',
        desc: "The visual aspect of a web app is the face of your brand. Hire web app developers to determine how your users will view and interact. They bring the web app's layout to life by building scripts and collaborating with dynamic libraries and frameworks.",
        img: frontend,
        link : '/ui-ux-design'
    },
    {
        title: 'Backend Developer',
        desc: "Want a clear picture of database structure, data processing, and third-party integrations? Our backend web applications developers will manage everything for you in a timely manner. They actively ensure that data is exchanged securely and efficiently.",
        img: backend,
        link : '/hire-nodejs-developer'

    },
    {
        title: 'Product Manager',
        desc: 'Our domain-savvy product manager keeps the team focused and protects the project scope. They are in charge of the budget, planning, and ensuring that the team is filled with the greatest minds.',
        img: product,
        link : '/contact-us'

    },
    {
        title: 'Designer',
        desc: 'UI/UX Designers are responsible for the whole appearance and feel of a web application, including the User Interface (UI) and User Experience (UX) design. They impact design decisions since they are in charge of the entire product design, including color, typeface, navigation, and other elements.',
        img: designer,
        link : '/ui-ux-design'
    },
    {
        title: 'Quality Assurance Engineer',
        desc: 'Our Q/A testing does not occur at the conclusion of the development process. Instead, the process begins once the team has created a UI layout and continues till the launch stage. To guarantee that the design meets the criteria, our QA assurance engineer will use automated or manual testing methods.',
        img: quality,
        link : '/hire-sqa-engineers'
    },
]
}

export const developmentProcessData = {
    title1: 'A Snapshot Of Our Blockchain',
    title2: 'Development Process',
    desc: "Plan, design, develop, test and roll out each version of your web application with zero downtime.",
    processNames: ['Planning', 'Design', 'Prototype', 'Development', 'Software Quality Assurance', 'DevOps Services', 'Support & Maintenance'],
   processInfo : [
    {
        title: 'Planning',
        desc: 'Outline all procedures and activities necessary to ensure project success and develop a complete set of plans to manage the project from this phase till project completion. It provides a clear structure of scope, deliverables, processes, budget, tech stack and timeline.',
        img: planning,
        link : '/contact-us'
    },
    {
        title: 'Design',
        desc: 'To create a marketable product, refine your ideas through market research validation. Save expenses and eliminate risks by working with our focused web application development team that moves smoothly through numerous iterations and launches high-functioning prototypes via a streamlined MVP development approach.',
        img: prototype,
        link : '/ui-ux-design'
    },
    {
        title: 'Development',
        desc: 'With our well-established bespoke web application development services, your brand will stand out from the crowd. Build safe, scalable, accessible, and custom software solutions with our specialized SCRUM team - tailored to your firm’s specifications and market expectations.',
        img: deployment,
        link : '/'

    },
    {
        title: 'Software Quality Assurance',
        desc: 'Reduce errors in your codes and interfaces with our automated software quality assurance geared toward higher ROI. To provide the greatest experience for your consumers, we use fine-tuned tools and construct sturdy walls with our penetration testing services.',
        img: quality,
        link : '/hire-sqa-engineers'

    },
    {
        title: 'DevOps Services',
        desc: 'With our well-engineered DevOps services, you can transition to continuous delivery and ensure durable data pipelines and speedier time-to-market. We integrate your existing infrastructure into a strong ecosystem using agile approaches while maintaining software quality.',
        img: devops,
        link : '/hire-sqa-engineers'

    },
    {
        title: 'Support & Maintenance',
        desc: "Deliver high-performance software to your customers by choosing our advanced web app development strategy, which includes bug-fixing, on-call production support, product improvements, user support, and training. Use Codezone's qualified personnel to optimize the functionalities of your product.",
        img: support,
        link : '/software-development'

    },
]
}

export const DevelopmentServicesData = {
    title1: 'A Wide Range of Blockchain',
    title2: 'Development Services',
    desc: 'Light years ahead of our competitors, CodeZone offers Blockchain development services and uses the latest technologies that will compel your customers to spend lavishly on your products.',
    cards: [
        {
            title: 'Supply Chain Management Web Apps',
            desc: 'Outsource web app development services to us and develop automated software to streamline the interconnected network of suppliers, manufacturers, warehouses, distributors and retailers.',
            img: supplyChain
        },
        {
            title: 'Progressive Web Applications (PWAs)',
            desc: 'Invest your hard-earned money in progressive web app development to provide accessible and user-friendly online experiences.',
            img: progressive
        },
        {
            title: 'Enterprise Web Apps',
            desc: 'Build industry-standard enterprise web apps by using our customer-centric agile methodologies and keep your business competitive.',
            img: enterprise
        },
        {
            title: 'Web Application Consulting',
            desc: 'Our team enjoys the challenge of working on uncharted prospects and helps with brainstorming, analysis, and finalizing the solution landscape for web application development.',
            img: webConsulting
        },
        {
            title: 'Cloud-Based Web Apps',
            desc: 'Hire our developers to leverage the competency of hosting web apps in the cloud, which provides additional benefits such as scale, affordability, security, and high uptime.',
            img: cloudBased
        },
        {
            title: 'Web Portals',
            desc: 'Partner with Codezone to leverage the competency to host web apps in the cloud, which provides additional benefits such as scale, affordability, security, and high uptime.',
            img: portals
        },

    ]
}
export const hireWebData = {
    title1: 'Hire Blockchain Developers To Extend',
    title2: 'The Roots of Your Business',
    desc: 'Get ready to elevate the performance and extend the functionalities of your metaverse by hiring our web application developers today!',
    questions: [
        {
            question: 'Good Decision-Making Skills',
            answer: 'Identify project risks and threats by leveraging the experience and technical expertise of our metaverse developers. They have the skills to predict trends and mitigate difficulties.',
            img: decision
        },
        {
            question: 'Enriched Experience',
            answer: 'Our senior Blockchain developers, with over 10,000 hours of work on diverse web app development projects, have faced several obstacles, which gives them a broader worldview while presenting answers. Their experiences also provide them with new perspectives on how to approach a project.',
            img: experience
        },
        {
            question: 'Problem Solvers & Risk Managers',
            answer: "Identify project risks and threats by leveraging the experience and technical expertise of our metaverse developers. They have the skills to predict trends and mitigate difficulties.",
            img: problemSolver
        },
    ]
}

export const ModelData = {
    title1: 'A Glance At Our Customer-Centric',
    title2: 'Engagement Models',
    desc: 'Choose a business engagement model that best fits your preferences.',
    img,
    tags: ['Resource Augmentation', 'Dedicated Team', 'Fixed Gig']
}

export const techData = {
    title1: 'Our Favorite Folder Of The',
    title2: 'Technologies We Use',
    images: [
        myimg1,
        myimg2,
        myimg3,
        img4,
        img5,
        img6,
        img7,
        img9,
        img10,
        img11,
        img12,
        img13,
        img14,
        img15,
        img16,
        img17,
        img18,
        img19,
        img20,
        img22,
        img23,
        img24,


    ]
}

export const reviewData = {
    title1: 'Cultivating Long-Term',
    title2: 'Relationships',
    sliderData: [
        {
            title: 'review 1',
            img: review,
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis repellendus quidem voluptatem aspernatur, quisquam cum debitis quis consectetur dolor voluptates cumque laboriosam! Possimus architecto nisi omnis veritatis minus ab minima.  ',
            rating: 2
        },
        {
            title: 'review 2',
            img: review,
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis repellendus quidem voluptatem aspernatur, quisquam cum debitis quis consectetur dolor voluptates cumque laboriosam! Possimus architecto nisi omnis veritatis minus ab minima.  ',
            rating: 3.5
        },
        {
            title: 'review 3',
            img: review,
            desc: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Nobis repellendus quidem voluptatem aspernatur, quisquam cum debitis quis consectetur dolor voluptates cumque laboriosam! Possimus architecto nisi omnis veritatis minus ab minima.  ',
            rating: 5,
        },
    ]
}

export const FAQData  = [
{
    question : 'What is Blockchain?',
    answer : 'Blockchain is a decentralized, distributed ledger technology that allows for secure, transparent, and tamper-proof transactions and data storage.'
},
{
    question : 'What are some popular blockchain platforms?',
    answer : "Popular blockchain platforms include Bitcoin, Ethereum, Ripple, and Hyperledger."
},
]